import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle } from 'lucide-react';

const Certifications = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-[#0f172a] border-y border-[#1e40af]">
      <div className="container mx-auto px-8">
        <div className="text-center mb-12">
          <h2 className="heading-3 text-[#1e40af] mb-4">{t.certifications.title}</h2>
          <p className="body-medium text-[#94a3b8]">{t.certifications.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {t.certifications.items.map((cert, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 bg-[#1e293b] p-4 border border-[#1e40af]"
            >
              <CheckCircle className="w-6 h-6 text-[#60a5fa] flex-shrink-0" />
              <span className="body-small text-[#60a5fa] font-medium">{cert}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
